'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('createapp', {
      url: '/editapp',
      template: '<createapp></createapp>'      
    })
    .state('editapp', {
      url: '/editapp/:id',
      template: '<createapp></createapp>'
    });
}



// WEBPACK FOOTER //
// ./client/app/createapp/createapp.routes.js